module.exports = __webpack_public_path__ + "zilky-v-obliceji_6_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/zilky-v-obliceji_6_after_tn.jpg
// module id = 1471
// module chunks = 0